import { cn } from './chunk-FFX3LZW7.js';
import { Loader2 } from 'lucide-react';
import { jsxs, jsx } from 'react/jsx-runtime';

var SIZES = {
  sm: "size-4",
  md: "size-5",
  lg: "size-8"
};
function Spinner({ size = "md", className, label = "Loading" }) {
  return /* @__PURE__ */ jsxs("span", { role: "status", "aria-live": "polite", className: "inline-flex items-center", children: [
    /* @__PURE__ */ jsx(Loader2, { className: cn("animate-spin text-muted-foreground", SIZES[size], className) }),
    /* @__PURE__ */ jsx("span", { className: "sr-only", children: label })
  ] });
}

export { Spinner };
//# sourceMappingURL=chunk-G3N5GV7A.js.map
//# sourceMappingURL=chunk-G3N5GV7A.js.map